module.exports = __webpack_public_path__ + "img/catalog-fill.4620f552.svg";